/**
 * @generated SignedSource<<0284d013f1a1492d9543b8215a47b705>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LearnableKind = "Course";
export type offers_Query$variables = {
  after?: string | null;
  before?: string | null;
  first?: number | null;
  isVisible?: boolean | null;
  kinds: ReadonlyArray<LearnableKind>;
  last?: number | null;
  tagIds: ReadonlyArray<string>;
  text?: string | null;
};
export type offers_Query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"offersFilters_QueryFragment" | "offersTable_QueryFragment">;
};
export type offers_Query = {
  response: offers_Query$data;
  variables: offers_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isVisible"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "kinds"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tagIds"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "text"
},
v8 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "before",
    "variableName": "before"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "isVisible",
    "variableName": "isVisible"
  },
  {
    "kind": "Variable",
    "name": "kinds",
    "variableName": "kinds"
  },
  {
    "kind": "Variable",
    "name": "last",
    "variableName": "last"
  },
  {
    "kind": "Variable",
    "name": "tagIds",
    "variableName": "tagIds"
  },
  {
    "kind": "Variable",
    "name": "text",
    "variableName": "text"
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startCursor",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endCursor",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNextPage",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasPreviousPage",
  "storageKey": null
},
v16 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "offers_Query",
    "selections": [
      {
        "args": (v8/*: any*/),
        "kind": "FragmentSpread",
        "name": "offersTable_QueryFragment"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "offersFilters_QueryFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Operation",
    "name": "offers_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminQueryType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LearnableAdminSchema",
            "kind": "LinkedField",
            "name": "Learnable",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v8/*: any*/),
                "concreteType": "UnpublishedLearnablesConnection",
                "kind": "LinkedField",
                "name": "UnpublishedLearnables",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnpublishedLearnablesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "kind",
                            "storageKey": null
                          },
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isUnpublishedLearnable"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TreeNode",
                                "kind": "LinkedField",
                                "name": "root",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "hasBeenPublishedOnce",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "structureDefinition",
                                    "plural": false,
                                    "selections": [
                                      (v9/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "title",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "UnpublishedCourseLearnable",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__id",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v8/*: any*/),
                "filters": [
                  "text",
                  "tagIds",
                  "isVisible",
                  "kinds"
                ],
                "handle": "connection",
                "key": "offersTable_UnpublishedLearnables",
                "kind": "LinkedHandle",
                "name": "UnpublishedLearnables"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AcademiesTagAdminSchema",
            "kind": "LinkedField",
            "name": "AcademiesTag",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v16/*: any*/),
                "concreteType": "AcademiesTagsConnection",
                "kind": "LinkedField",
                "name": "SelectTags",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AcademiesTagsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isAcademiesTag"
                          },
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AcademiesTagData",
                            "kind": "LinkedField",
                            "name": "data",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "name",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isClickable",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isTopic",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "SelectTags(first:20)"
              },
              {
                "alias": null,
                "args": (v16/*: any*/),
                "filters": [
                  "name",
                  "isTopic",
                  "isClickable",
                  "isRoot"
                ],
                "handle": "connection",
                "key": "selectAcadamiesTagField_SelectTags",
                "kind": "LinkedHandle",
                "name": "SelectTags"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "91ad9d43cc1cbeda8820dbb0e1822016",
    "id": null,
    "metadata": {},
    "name": "offers_Query",
    "operationKind": "query",
    "text": "query offers_Query(\n  $first: Int\n  $after: String\n  $before: String\n  $last: Int\n  $tagIds: [ID!]!\n  $isVisible: Boolean\n  $kinds: [LearnableKind!]!\n  $text: String\n) {\n  ...offersTable_QueryFragment_4peOxi\n  ...offersFilters_QueryFragment\n}\n\nfragment deleteCourseLearnableButton_UnpublishedLearnableFragment on UnpublishedLearnable {\n  __isUnpublishedLearnable: __typename\n  id\n  kind\n  ... on UnpublishedCourseLearnable {\n    kind\n    root {\n      id\n      structureDefinition {\n        __typename\n        title\n      }\n    }\n  }\n}\n\nfragment editCourseLearnableButton_UnpublishedLearnableFragment on UnpublishedLearnable {\n  __isUnpublishedLearnable: __typename\n  id\n  ... on UnpublishedCourseLearnable {\n    kind\n    root {\n      id\n    }\n  }\n}\n\nfragment offersFilters_QueryFragment on Query {\n  ...selectAcademiesTagField_QueryFragment\n}\n\nfragment offersTable_QueryFragment_4peOxi on Query {\n  Admin {\n    Learnable {\n      UnpublishedLearnables(first: $first, after: $after, last: $last, before: $before, text: $text, tagIds: $tagIds, isVisible: $isVisible, kinds: $kinds) {\n        edges {\n          node {\n            __typename\n            id\n            kind\n            ...offersTable_UnpublishedLearnableFragment\n          }\n          cursor\n        }\n        pageInfo {\n          startCursor\n          endCursor\n          hasNextPage\n          hasPreviousPage\n        }\n      }\n    }\n  }\n}\n\nfragment offersTable_UnpublishedLearnableFragment on UnpublishedLearnable {\n  __isUnpublishedLearnable: __typename\n  id\n  kind\n  ... on UnpublishedCourseLearnable {\n    root {\n      id\n      hasBeenPublishedOnce\n      structureDefinition {\n        __typename\n        title\n      }\n    }\n  }\n  ...editCourseLearnableButton_UnpublishedLearnableFragment\n  ...deleteCourseLearnableButton_UnpublishedLearnableFragment\n}\n\nfragment selectAcademiesTagField_AcademiesTagFragment on AcademiesTag {\n  __isAcademiesTag: __typename\n  id\n  data {\n    name\n    isClickable\n    isTopic\n  }\n}\n\nfragment selectAcademiesTagField_QueryFragment on Query {\n  Admin {\n    AcademiesTag {\n      SelectTags(first: 20) {\n        edges {\n          node {\n            __typename\n            ...selectAcademiesTagField_AcademiesTagFragment\n            id\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n          hasPreviousPage\n          startCursor\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f2d2b995d082da423d127578246015a1";

export default node;
